export enum RouteNames {
  Hazards = 'hazards',
  HazardById = 'hazard-by-id',
  HazardByType = 'hazard-by-type',
  TextVersion = 'text-version',
  TextVersionById = 'text-version-by-id',
  About = 'about',
  MapIcons = 'map-icons',
  MapGuide = 'map-guide',
  MyEmergencyPlan = 'my-emergency-plan',
  MyEmergencyPlanShare = 'my-emergency-plan-share',
  MyEmergencyPlanRedeemInAppPlan = 'my-emergency-plan-redeem-in-app-plan',
  FeatureFlags = 'feature-flags',
}
